/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type MailboxResponseStatus = typeof MailboxResponseStatus[keyof typeof MailboxResponseStatus];


export const MailboxResponseStatus = {
  connected: 'connected',
  needs_reconnect: 'needs_reconnect',
  disconnected: 'disconnected',
} as const;
